import { createJSONStorage, persist } from 'zustand/middleware';
import { createWithEqualityFn as create } from 'zustand/traditional';

interface TaskFilterStoreValues {
    query: string;
    sortBy: 'due_at' | undefined;
    sortByDesc: 'created_at' | undefined;
}

interface TaskFilterStoreSetters {
    setQuery: (query: string) => void;
    setSortBy: (sortBy: TaskFilterStoreValues['sortBy']) => void;
    setSortByDesc: (sortByDesc: TaskFilterStoreValues['sortByDesc']) => void;
}

type TaskFilterStore = TaskFilterStoreValues & TaskFilterStoreSetters;

const useTasksFilterStore = create<TaskFilterStore>()(
    persist(
        set => ({
            query: '',
            setQuery: query => set({ query }),
            sortBy: undefined,
            setSortBy: sortBy => set({ sortBy }),
            sortByDesc: 'created_at',
            setSortByDesc: sortByDesc => set({ sortByDesc }),
        }),
        {
            name: 'givebutter-taskFilterStore-state',
            storage: createJSONStorage(() => localStorage),
        },
    ),
);

const taskFilterValuesSelector = ({ query, sortBy, sortByDesc }: TaskFilterStore) => {
    return {
        query,
        sortBy,
        sortByDesc,
    };
};

export { useTasksFilterStore, taskFilterValuesSelector };
export type { TaskFilterStore, TaskFilterStoreValues, TaskFilterStoreSetters };
